import React from 'react';
import './App.css'; 
import './index.css'; 
const Home = () => {
    return ( 
        <>
        <div className="page-background">
        <img className='logo-image' src="image/logo.jpg" alt="Logo"/>
        <p className="centered-paragraph">
        the app simplifies event management, allowing you to effortlessly create, track, and organize your important events directly from your mobile device. With features such as easy event management, countdown timers to upcoming events, and efficient planning tools, our app is designed to provide a user-friendly solution for anyone seeking to effectively manage their schedule and stay on top of their commitments.
        </p>
        <a href='https://apps.apple.com/app/id6743360139?platform=iphone'>
        <img className='download-image' src="image/download.svg" alt="download"/>
        </a>
        <div id="links">
  <a href='/privacyPolicy'>Privacy Policy</a> |
  <a href='/termsOfUse'>Terms Of Use</a> |
  <a href='/accessibilityStatement'>Accessibility Statement</a>
</div> 
        </div>
        </>
     );
}
 
export default Home;